import { createSha256Hasher } from './sha256.hasher.js';

/**
 * Calculate SHA256 hash from bytes
 */
export function sha256Fallback(bytes: Uint8Array): string {
  return createSha256Hasher().update(bytes).digest();
}
